/**
 * Global styles must live in this file (Next.js). First-party `*.css` cannot be imported from components.
 * Slick: vendor CSS from `node_modules` is only allowed here alongside our overrides (order matters).
 */
import "@/styles/globals.css";
import "@/styles/forms-heavy.css";
// First-party global CSS must be imported here (Next.js). `slick-carousel/*.css` may load from pages;
// our overrides target `.slick-*` and must stay in App.
import "@/styles/slick-overrides.css";
import "@/styles/waitlist.css";
import "react-phone-input-2/lib/style.css";
import AppShell from "@/components/AppShell";

function AppWithGlobalStyles({ Component, pageProps }) {
  return <AppShell Component={Component} pageProps={pageProps} />;
}

export default AppWithGlobalStyles;
